// extracted by mini-css-extract-plugin
export default {"homework":"homeworkBlock_homework__YWHd3","title":"homeworkBlock_title__wpEWv","desc":"homeworkBlock_desc__pNSy-","btn":"homeworkBlock_btn__-ZNvV"};